<template>
    <v-row>
        <v-col cols="12">
            <v-expansion-panels accordion multiple tile v-model="expansionpanelmodel">
                <v-expansion-panel v-for="(group, groupindex) in groups" v-bind:key="groupindex" v-bind:value="group.id">
                    <v-expansion-panel-header class="grey lighten-4 primary--text font-weight-bold" style="min-height: 0 !important">
                        {{ $t(group.name) }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div v-for="(mainquestion, mainquestionindex) in mainquestionsofgroups(group.id)" v-bind:key="mainquestionindex" class="rounded border pa-2 mt-2" v-bind:class="{'border-danger' : mainquestion.error}">
                            <span class="subtitle-2 font-weight-bold" v-bind:class="{'error--text' : mainquestion.error}"> {{ mainquestionindex + 1 }} - {{ mainquestion.soru }}</span>
                            <hr class="my-2" />
                            <KSurveyQuestion v-bind:question="mainquestion" v-bind:ischild="false" v-bind:props="props" />
                            <div v-for="(childquestion, childquestionindex) in childquestionsofmainquestion(mainquestion.id)" v-show="ischildquestionisvisible(mainquestion, childquestion)" v-bind:key="childquestionindex" class="rounded border pa-2 mt-2" v-bind:class="{'border-danger' : childquestion.error}">
                                <span class="text-body-2"> {{ String.fromCharCode(97 + childquestionindex) }} - {{ childquestion.soru }}</span>
                                <KSurveyQuestion v-bind:question="childquestion" v-bind:ischild="true" v-bind:props="props" />
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue';
    import Vuex from 'vuex';
    Vue.use(Vuex);

    import 'material-design-icons-iconfont/dist/material-design-icons.css';
    import { FormMixIn } from '@/MixIns/FormMixins';
    import KSurveyQuestion from '@/components/KSurveyQuestion.vue';

    export default {
        name: 'KSurvey',
        mixins: [FormMixIn],
        components: {
            KSurveyQuestion
        },
        props: {
            questions: Array,
            props: Object
        },
        data()
        {
            return {
                expansionpanelmodel: []
            };
        },
        computed: {
            groups()
            {
                return Array.from(new Set(this.questions.map(item => JSON.stringify({ id: item.sorugrupid, name: item.sorugrupadi })))).map(item => JSON.parse(item));
            }
        },
        watch: {
            groups(newVal, oldVal)
            {
                if (newVal !== oldVal)
                {
                    this.expansionpanelmodel = Array(newVal.length).fill().map((_, idx) => 0 + idx)
                }
            }
        },
        methods: {
            mainquestionsofgroups(groupId)
            {
                return this.questions.filter(item => item.sorugrupid === groupId && Number(item.baglisoruid) === 0);
            },
            childquestionsofmainquestion(parentQuestionId)
            {
                return this.questions.filter(item => Number(item.baglisoruid) === parentQuestionId);
            },
            ischildquestionisvisible(parentQuestion, childQuestion)
            {
                switch (parentQuestion.tip)
                {
                    case "radio":
                        return parentQuestion.cevap === childQuestion.baglisecenek;
                    case "checkbox":
                        return parentQuestion.cevap.split(";").includes(childQuestion.baglisecenek);
                    default:
                        return false;
                }
            }
        },
        mounted() { }
    };
</script>
